import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faDiscord, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router";

const Socials = () => {
  const X = <FontAwesomeIcon icon={faXTwitter} />;
  const discord = <FontAwesomeIcon icon={faDiscord} />;
  const email = <FontAwesomeIcon icon={faEnvelope} />;
  return (
    <div className="hidden lg:fixed lg:flex flex-col justify-center items-center gap-5 h-screen w-24">
      <Link to={"/unavailable"}>{discord}</Link>
      <Link to={"/unavailable"}>{X}</Link>
      <Link to={"/unavailable"}>{email}</Link>
    </div>
  );
};

export default Socials;
